import { create } from 'zustand';
import { Material } from '../../sp-types/materialType';

const initialMaterialState: Material[] = [];

// Next set function - just need to write a generic setter
interface MaterialsStore {
  materials: Material[];
  materialsMap: Record<string, Material>;
  materialsPriceMap: Record<string, number>;
  isMaterialsLoading: boolean;
  setMaterials: (_value: Material[]) => void;
  setIsMaterialsLoading: (_value: boolean) => void;
}

export const useMaterialsStore = create<MaterialsStore>((set) => ({
  materials: initialMaterialState,
  materialsMap: {},
  materialsPriceMap: {},
  isMaterialsLoading: false,
  setIsMaterialsLoading: (value: boolean) => set({ isMaterialsLoading: value }),
  setMaterials: (value: Material[]) =>
    set({
      materials: value,
      materialsMap: value.reduce((arr, item) => ({ ...arr, [item.id]: item }), {}),
      materialsPriceMap: value.reduce((priceMap, item) => ({ ...priceMap, [item.id]: item.currentPrice }), {}),
    }),
}));
